export function camelToSnakeCase(value: string) {
  return (value || '').replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
